import { render, staticRenderFns } from "./LlQuestionRemarkPopup.vue?vue&type=template&id=187fced7"
import script from "./LlQuestionRemarkPopup.vue?vue&type=script&lang=js"
export * from "./LlQuestionRemarkPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports